import React, { FC, useEffect, useState } from "react";
import {
  Container,
  InputWrapper,
  ButtonWrapper,
  DatePickerWrapper,
} from './styles'
import { billingService } from "../../../../api";
import { useNavigate, useParams } from "react-router-dom";
import { BigAlert, Button, Input, Label, TopProgress, Typography, DatePickerCustom } from "../../../../components";
import { useTranslation } from "react-i18next";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import * as yup from 'yup';
import { useFormik } from 'formik';
import { now, getLocalTimeZone } from "@internationalized/date";
import './index.css'
import { useAuth } from "../../../../context/user.context";
import { parseApiDateToDateValue, dateValueToDateAndTimeFields } from "../../../../components/date-picker/utils";



const JournalItemEdit:FC = ( ) => {
  const [data, setData] = useState<any>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false);
  const [initialValues, setInitialValues ] = useState<any>({
    description:'',
  })
  const [expire, setExpire] = useState<any>()
  const [value, setValue] = useState<any>();


  const navigate = useNavigate()
  const {journalId} = useParams()
  const [t] = useTranslation()
  const getData = async () => {
    if(!journalId) return;
    try{
      const res = await billingService.getJournalItem(journalId)
      setData({
        ...res.data,
        destination: res.data.destination_info.name,
        source: res.data.source_name,
      });
      setInitialValues({
        destination: res.data.destination_info.name,
        source: res.data.source_name,
        amount: res.data.destination_amount,
      })
      setPageLoading(false);


      const datePickerValue = parseApiDateToDateValue(res.data.date_added);
      setValue(datePickerValue || undefined);

    } catch(err:any) {
      console.log('err',err);
    }
  }
  useEffect(() => {
    getData()
    const interval = setInterval(() => {
      getData()
    },20000)
    return () => {
      clearInterval(interval)
    }
  },[])
  const onSubmit = async (values:any) => {
    if(!journalId) return;
    setLoading(true)
    try{
      const entry:any = {
        amount:values?.amount,
        id:journalId,
      }
      if(expire) {
        entry.date_added = expire.date_added;
        entry.date_added_time = expire.date_added_time;
      } else {
        entry.date_added = data.date_added;
      }

      console.log('expire',expire);
      const res = await billingService.editJournalItem(journalId, entry)
      setTimeout(() => {
        setLoadingComplete(true)
        setTimeout(() => {
          setLoading(false)
          setLoadingComplete(false)
          // navigate(-1)
        },1000)
      })
    } catch(err:any){
      console.log('err',err);
    }
  }
  const {
    values,
    errors,
    touched,
    setErrors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      amount: yup.string(),
      destination: yup.string().required(),
      source: yup.string().required(),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  if(pageLoading) return <TopProgress loading={pageLoading}/>

  return(
    <Container>
      <Typography variant="h3">{t("EDIT_JOURNAL_ENTRY")}</Typography>
      <BigAlert
        // severity="info"
        message={t("Updating a journal entry reverses related credit added to client balance and/or paid invoice.")}
        customStyles={{ marginBottom: "20px"}}
      />
      <InputWrapper>
        <Input
          required
          title={`${t('SOURCE')}`} 
          disabled
          fieldName='source'
          placeholder={''}
          onBlur={handleBlur}
          {...formikProps}
        />
        <Input
          required
          title={`${t('DESTINATION')}`} 
          fieldName='destination'
          disabled
          placeholder={''}
          onBlur={handleBlur}
          {...formikProps}
        />
        <Input
          required
          title={`${t('AMOUNT')} ${data?.source_currency}`} 
          fieldName='amount'
          placeholder={''}
          type='number'
          onBlur={handleBlur}
          {...formikProps}
        />
        <DatePickerWrapper>
          <Label required={true} toolTip={false} title={t("DATE")} />
          <DatePickerCustom
            label={t("EXPIRATION_DATE")}
            value={value}
            onChange={(e:any) => {
              setValue(e);
              const nextFields = dateValueToDateAndTimeFields(e);
              if(nextFields){
                setExpire({
                  date_added: nextFields.iso,
                  date_added_time: nextFields.time
                });
              } else {
                setExpire(undefined);
              }
            }}
            hideTimeZone
            showMonthAndYearPickers
            defaultValue={now(getLocalTimeZone())}
          />
        </DatePickerWrapper>
      </InputWrapper>
      <ButtonWrapper>
        <Button
          variant="primary"
          size="display"
          onClick={handleSubmit}
          loading={loading}
          loadingComplete={loadingComplete}
          title={t("SAVE")}
        />
        <Button
          variant="stroke"
          size="display"
          onClick={() => navigate(-1)}
          title={t("CANCEL")}
        />
      </ButtonWrapper>
    </Container>
  )
}

export default JournalItemEdit
